'use client';

import * as stylex from '@stylexjs/stylex';
import { Cookie } from 'lucide-react';
import { useCallback, useContext } from 'react';
import { Button } from '../Buttons';
import { CookieNotificationContext } from './context';
import { CookieDecision } from './types';
export type SetCookieButtonProps = {
  decision: CookieDecision;
  styles?: stylex.StyleXStyles;
} & React.ComponentProps<'button'>;
export type OpenSettingButtonProps = {
  styles?: stylex.StyleXStyles;
} & React.ComponentProps<'button'>;
export function SetCookieButton({
  decision,
  styles,
  children,
  ...props
}: SetCookieButtonProps) {
  const {
    acceptAllConsent,
    declineAllConsent,
    closePopover,
    closeSettings
  } = useContext(CookieNotificationContext);
  async function handleClick() {
    if (decision === 'accept') {
      await acceptAllConsent();
    } else {
      await declineAllConsent();
    }
    closePopover();
    closeSettings();
  }
  return <Button onClick={handleClick} styles={styles} variant={decision === 'accept' ? 'solid' : 'link'} theme={decision === 'accept' ? 'primary' : 'neutral'}>
      {children || (decision === 'accept' ? 'Accept' : 'Reject')}
    </Button>;
}
export function OpenSettingsButton({
  styles,
  children,
  ...props
}: OpenSettingButtonProps) {
  const {
    openSettings,
    closePopover
  } = useContext(CookieNotificationContext);
  const handleClick = useCallback(() => {
    closePopover();
    openSettings();
  }, [openSettings, closePopover]);
  return <Button onClick={handleClick} styles={styles} variant="link" theme="neutral">
      {children}
    </Button>;
}
export function OpenCookieSettingsButton(props: React.ComponentProps<typeof Button>) {
  const {
    openSettings
  } = useContext(CookieNotificationContext);
  return <Button onClick={openSettings} variant="ghost" iconLeft={<Cookie />} {...props}>
      Manage Cookies
    </Button>;
}
type PopoverProps = {
  styles?: stylex.StyleXStyles;
  children?: React.ReactNode;
};
export function Popover({
  styles,
  children
}: PopoverProps) {
  const {
    popoverRef
  } = useContext(CookieNotificationContext);
  return <div {...stylex.props(styles)} ref={popoverRef} popover="manual" aria-label="Cookie Policy Notice - Press to accept">
      {children}
    </div>;
}